// extracted by mini-css-extract-plugin
module.exports = {"Errors":"ShippingInformationForm_Errors__FgSlf"};